export default __webpack_public_path__ + "static/media/2.80ca9368.png";